import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
import { SearchWithAutocomplete, Suggestion } from '../../../../components/UI/SearchWithAutocomplete';
import { useDarkClasses } from '../../../../hooks/useDarkClasses';
import { useRoleTheme } from '../../../../hooks/useRoleTheme';
// ─── Multi-select: SearchWithAutocomplete + removable chips ───
export const SearchableChipField: React.FC<{
  label: string;
  placeholder: string;
  items: string[];
  selected: string[];
  onToggle: (item: string) => void;
  accentClass: string;
  maxVisible?: number;
}> = ({
  label,
  placeholder,
  items,
  selected,
  onToggle,
  accentClass
}) => {
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  const [search, setSearch] = useState('');
  const suggestions: Suggestion[] = items.filter(item => !selected.includes(item)).map(item => ({
    id: item.toLowerCase().replace(/\s+/g, '-'),
    label: item,
    type: label.split(' ')[0]
  }));
  return <div data-id="element-21407" data-mp="14h91ecm0iofn">
      <label className={`block text-sm font-medium mb-1 ${dk.textSecondary}`} data-id="element-21408" data-mp="kt1d2l6n839q">
        {label}
      </label>
      <SearchWithAutocomplete value={search} onChange={setSearch} suggestions={suggestions} placeholder={placeholder} onSelect={item => {
      if (!selected.includes(item.label)) {
        onToggle(item.label);
      }
      setSearch('');
    }} data-id="element-21409" data-mp="fu6n8za9deg4" />
      {selected.length > 0 && <div className="flex flex-wrap gap-1.5 mt-2" data-id="element-21410" data-mp="16ljd35k7b75">
          {selected.map(item => <span key={item} className={`inline-flex items-center px-2.5 py-0.5 ${rt.badgeRadius} text-xs font-medium ${accentClass}`} data-id="element-21411" data-mp="3t79oigh1adeo">
              {item}
              <button onClick={() => onToggle(item)} className="ml-1.5 hover:opacity-75" data-id="element-21412" data-mp="3jc7zrlqo7dcm">
                <XIcon className="w-3 h-3" data-id="element-21413" data-mp="1mg0q4m3zvwhb" />
              </button>
            </span>)}
        </div>}
    </div>;
};
// ─── Single-select: SearchWithAutocomplete → chip when selected ───
export const SingleSelectField: React.FC<{
  label: string;
  placeholder: string;
  items: string[];
  value: string;
  onChange: (val: string) => void;
  accentClass: string;
}> = ({
  label,
  placeholder,
  items,
  value,
  onChange,
  accentClass
}) => {
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  const [search, setSearch] = useState('');
  const suggestions: Suggestion[] = items.map(item => ({
    id: item.toLowerCase().replace(/\s+/g, '-'),
    label: item,
    type: label.split(' ')[0]
  }));
  return <div className="mb-6" data-id="element-21414" data-mp="3ks2itn3816eq">
      <label className={`block text-sm font-medium mb-1 ${dk.textSecondary}`} data-id="element-21415" data-mp="3kqsnh5nr6cbs">
        {label}
      </label>
      {value && <div className="flex flex-wrap gap-1.5 mt-2" data-id="element-21416" data-mp="3pp2jfihaxgyg">
          <span className={`inline-flex items-center px-2.5 py-0.5 ${rt.badgeRadius} text-xs font-medium ${accentClass}`} data-id="element-21417" data-mp="29cdxf05m8fg1">
            {value}
            <button onClick={() => onChange('')} className="ml-1.5 hover:opacity-75" data-id="element-21418" data-mp="we52r7f8lsc5">
              <XIcon className="w-3 h-3" data-id="element-21419" data-mp="rftrqtd7hbsc" />
            </button>
          </span>
        </div>}
    </div>;
};